import { render, staticRenderFns } from "./FormatSize.vue?vue&type=template&id=b3ae2874&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatSize.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatSize.vue
// module id = 1727
// module chunks = 1